export let countriesList = ['Polska','Afganistan',
    'Albania',
    'Algieria',
    'Andora',
    'Angola',
    'Anguilla',
    'Antigua i Barbuda',
    'Arabia Saudyjska',
    'Argentyna',
    'Armenia',
    'Aruba',
    'Australia',
    'Austria',
    'Azerbejdżan',
    'Bahamy',
    'Bahrajn',
    'Bangladesz',
    'Barbados',
    'Belgia',
    'Belize',
    'Benin',
    'Bermudy',
    'Bhutan',
    'Białoruś',
    'Boliwia',
    'Bonaire',
    'Botswana',
    'Bośnia i Hercegowina',
    'Brazylia',
    'Brunei',
    'Brytyjskie Wyspy Dziewicze',
    'Burkina Faso',
    'Burundi',
    'Bułgaria',
    'Chile',
    'Chiny',
    'Chorwacja',
    'Curaçao',
    'Cypr',
    'Czad',
    'Czarnogóra',
    'Czechy',
    'Dania',
    'Demokratyczna Republika Konga',
    'Dominika',
    'Dominikana',
    'Dżibuti',
    'Egipt',
    'Ekwador',
    'Erytrea',
    'Estonia',
    'Etiopia',
    'Falklandy',
    'Fidżi',
    'Filipiny',
    'Finlandia',
    'Francja',
    'Gabon',
    'Gambia',
    'Ghana',
    'Gibraltar',
    'Grecja',
    'Grenada',
    'Grenlandia',
    'Gruzja',
    'Guam',
    'Guernsey',
    'Gujana',
    'Gujana Francuska',
    'Gwadelupa',
    'Gwatemala',
    'Gwinea',
    'Gwinea Bissau',
    'Gwinea Równikowa',
    'Haiti',
    'Hiszpania',
    'Holandia',
    'Honduras',
    'Hongkong',
    'Indie',
    'Indonezja',
    'Irak',
    'Iran',
    'Irlandia',
    'Islandia',
    'Izrael',
    'Jamajka',
    'Japonia',
    'Jemen',
    'Jersey',
    'Jordania',
    'Kajmany',
    'Kambodża',
    'Kamerun',
    'Kanada',
    'Katar',
    'Kazachstan',
    'Kenia',
    'Kirgistan',
    'Kiribati',
    'Kolumbia',
'Komory',
'Kongo',
'Korea Południowa',
'Korea Północna',
'Kostaryka',
'Kuba',
'Kuwejt',
'Laos',
'Lesotho',
'Liban',
'Liberia',
'Libia',
'Liechtenstein',
'Litwa',
'Luksemburg',
'Macedonia',
'Madagaskar',
'Majotta',
'Makau',
'Malawi',
'Malediwy',
'Malezja',
'Mali',
'Malta',
'Mariany Północne',
'Maroko',
'Martynika',
'Mauretania',
'Mauritius',
'Meksyk',
'Mikronezja',
'Mjanma',
'Monako',
'Mongolia',
'Montserat',
'Mozambik',
'Mołdawia',
'Namibia',
'Nauru',
'Nepal',
'Niemcy',
'Niger',
'Nigeria',
'Nikaragua',
'Niue',
'Norfolk',
'Norwegia',
'Nowa Kaledonia',
'Nowa Zelandia',
'Oman',
'Pakistan',
'Palau',
'Panama',
'Papua-Nowa Gwinea',
'Paragwaj',
'Peru',
'Pitcairn',
'Polinezja Francuska',
'Portoryko',
'Portugalia',
'Republika Południowej Afryki',
'Republika Zielonego Przylądka',
'Republika Środkowoafrykańska',
'Reunion',
'Rosja',
'Rumunia',
'Rwanda',
'Saba',
'Sahara Zachodnia',
'Saint Kitts i Nevis',
'Saint Lucia',
'Saint Vincent i Grenadyny',
'Saint-Barthélemy',
'Saint-Martin',
'Saint-Pierre i Miquelon',
'Salwador',
'Samoa',
'Samoa Amerykańskie',
'San Marino',
'Senegal',
'Serbia',
'Seszele',
'Sierra Leone',
'Singapur',
'Sint Eustatius',
'Sint Maarten',
'Somalia',
'Sri Lanka',
'Stany Zjednoczone',
'Strefa Gazy',
'Suazi',
'Sudan',
'Surinam',
'Svalbard',
'Syria',
'Szwajcaria',
'Szwecja',
'Słowacja',
'Słowenia',
'Tadżykistan',
'Tajlandia',
'Tajwan',
'Tanzania',
'Timor Wschodni',
'Togo',
'Tokelau',
'Tonga',
'Trynidad i Tobago',
'Tunezja',
'Turcja',
'Turkmenistan',
'Turks i Caicos',
'Tuvalu',
'Uganda',
'Ukraina',
'Urugwaj',
'Uzbekistan',
'Vanuatu',
'Wallis i Futuna',
'Watykan',
'Wenezuela',
'Wielka Brytania',
'Wietnam',
'Wybrzeże Kości Słoniowej',
'Wyspa Bożego Narodzenia',
'Wyspa Man',
'Wyspy Cooka',
'Wyspy Dziewicze Stanów Zjednoczonych',
'Wyspy Kokosowe',
'Wyspy Marshalla',
'Wyspy Owcze',
'Wyspy Salomona',
'Wyspy Świętego Tomasza i Książęca',
'Węgry',
'Włochy',
'Zachodni Brzeg',
'Zambia',
'Zimbabwe',
'Zjednoczone Emiraty Arabskie',
'Łotwa',
'Święta Helena']